export enum WatermarkFileType {
    PDF = 'PDF'
}